module.exports = __webpack_public_path__ + "assets/img/D.87bc13c9.png";